/** The per-scope AI state a form shell (`useFormShell`) exposes. */
export interface ScopeAiShell {
  processingScopes: ReadonlySet<string>;
  suggestionsCountByScope: ReadonlyMap<string, number>;
  stopScope: (scopeId: string) => void;
}

/** AI state of one scope — e.g. a buyer's own uploads, whose scope id is the buyer's `buyerKey`. */
export function getScopeAi(shell: ScopeAiShell, scopeId: string) {
  return {
    isProcessing: shell.processingScopes.has(scopeId),
    suggestionsCount: shell.suggestionsCountByScope.get(scopeId) ?? 0,
    stop: () => shell.stopScope(scopeId)
  };
}
